$(document).ready(function() {
  let is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if(is_safari) {$('body').addClass('mac-os')}
    var currentHref = window.location.href;
    $('.topbar .dropdown-country-flag li a').each(function() {
        if (currentHref.indexOf($(this).attr('href')) >= 0) {
            $(this).parent().hide();
            $('.topbar .current-country-flag').html($(this).html());
        }
    });
    $('.slideout__wrapper .dropdown-country-flag li a').each(function() {
        if (currentHref.indexOf($(this).attr('href')) >= 0) {
            $(this).parent().hide();
            $('.slideout__wrapper .current-country-flag').html($(this).html());
        }
    });

    if ( $(window).width() < 768) {
        $('.mega-menu--slideout .mega-menu__item .mega-menu__title-link').click(function(e) {
            e.stopPropagation();
            window.location.replace($(this).attr('href'));
        });
    }
    // //select
    var selectId = $("select").each(function () {
        selectId = $(this).attr('id')
        $('label[for="' + selectId + '"]').addClass('active');
    });
    //input
    function updateTextFields(input_selector) {
        setTimeout(function () {
            $(input_selector).each(function (index, element) {
                var $this = $(this);
                var inputId = $this.attr('id');
                if (inputId == undefined) {
                    inputId = $this.attr('name');
                }
                if ($(element).val().length > 0 || $(element).is(':focus') || element.autofocus) {
                    $('label[for="' + inputId + '"]').addClass('active');
                } else if ($(element)[0].validity.badInput) {
                    $('label[for="' + inputId + '"]').toggleClass('active', $(element)[0].validity.badInput === true);
                } else {
                    $('label[for="' + inputId + '"]').removeClass('active');
                }
                if ($(element).is(':focus')) {
                    $('label[for="' + inputId + '"]').addClass('focusing');
                } else {
                    $('label[for="' + inputId + '"]').removeClass('focusing');
                }
                // if ($(element).is(':-webkit-autofill')) {
                //     $('label[for="' + inputId + '"]').addClass('focusing');
                // } else {
                //     $('label[for="' + inputId + '"]').removeClass('focusing');
                // }
            });
        }, 300);
    };
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], textarea';
    updateTextFields(input_selector);
    $(document).on('change', input_selector, function () {
        var inputId = $(this).attr('id');
        if (inputId == undefined) {
            inputId = $(this).attr('name');
        }
        //console.log($(this).val());
        if ($(this).val().length !== 0 || $(this).attr('placeholder') !== undefined) {
            $('label[for="' + inputId + '"]').addClass('active');
        }
    });
    $(document).on('focus', input_selector, function () {
        var inputId = $(this).attr('id');
        if (inputId == undefined) {
            inputId = $(this).attr('name');
        }
        $('label[for="' + inputId + '"]').addClass('active');
        $('label[for="' + inputId + '"]').addClass('focusing');
    });
    $(document).on('blur', input_selector, function () {
        var inputId = $(this).attr('id');
        if (inputId == undefined) {
            inputId = $(this).attr('name');
        }
        if ($(this).val().length == 0) {
            $('label[for="' + inputId + '"]').removeClass('active');
        }
        $('label[for="' + inputId + '"]').removeClass('focusing');
    });
    /* Align height fyf page */
    function alignHeight(selector) {
        jQuery(selector).css('height', '');
        var maxHeightName = 0;
        jQuery(selector).each(function() {
            if (maxHeightName < jQuery(this).height()) {
            maxHeightName = jQuery(this).height()
            }
        });
        if (maxHeightName > 0) {
            jQuery(selector).css('height', maxHeightName);
        }
    }
    setTimeout(function(){
        alignHeight('.product-card--suggestions .product-card__inner .product-card__content .product-card__title ');

    }, 500);

    jQuery(window).resize(function() {
        setTimeout(function(){
            alignHeight('.product-card--suggestions .product-card__inner .product-card__content .product-card__title ');
        }, 500);
    });

    $(document).on('click', '.current-country-flag', function() {
        $(this).toggleClass('active');
        $(this).next().toggleClass('active-country-dropdown');
    })
    if ($('body.collection').length || $('body.search').length) {
        var cntTimes = 0;
        var cusfun = setInterval(function(){
            if ($('.bc-sf-filter-tree-wrapper').length) {
                var htmlTag = $('.bc-sf-filter-tree-wrapper >#bc-sf-filter-tree-h').html();
                if(htmlTag == ""){
                    console.log(1);
                    $('.bc-sf-filter-tree-wrapper >#bc-sf-filter-tree-h').parent().hide();
                    clearInterval(cusfun);
                }
            }
            if (cntTimes > 20) {
                clearInterval(cusfun);
            }
            cntTimes++;
        }, 500);
    }

    /* homepage search at < 1188px */
    $(document).on('click', '.header__main-menu .mega-menu__list > .mega-menu__item--has-submenu > .mega-menu__title', function(e) {
        e.preventDefault();
        if ($(this).next().hasClass('opening-megamenu-dropdown')) {
            $(this).next().removeClass('opening-megamenu-dropdown');
            $(this).removeClass('title-opening-dropdown');
        } else {
            $('.header__main-menu .mega-menu__list > .mega-menu__item--has-submenu > .mega-menu__submenu').removeClass('opening-megamenu-dropdown')
            $('.header__main-menu .mega-menu__list > .mega-menu__item--has-submenu > .mega-menu__title').removeClass('title-opening-dropdown')
            $(this).next().addClass('opening-megamenu-dropdown');
            $(this).addClass('title-opening-dropdown');
        }
    });
    // if ($(window).width() >= 1200) {
    //     $(document).on('mouseleave', 'header .mega-menu__submenu', function() {
    //         setTimeout(function() {
    //             if (!$('.mega-menu__list:hover').length) {
    //                 if ($('.mega-menu__title.title-opening-dropdown').length) {
    //                     $('.mega-menu__title.title-opening-dropdown').removeClass('title-opening-dropdown');
    //                     $('.mega-menu__submenu.opening-megamenu-dropdown').removeClass('opening-megamenu-dropdown');
    //                 }
    //             }
    //         }, 300);
    //     });
    // }

    $(document).on('click', '.collection #modal-cart-noti .modal__button, .search #modal-cart-noti .modal__button, .collection #modal-cart-noti .button--alternate, .search #modal-cart-noti .button--alternate, .product #modal-cart-noti .button--alternate', function(e) {
        e.preventDefault();
        $(this).closest('#modal-cart-noti').remove();
    });

    /* instafeed slider on tablet */
    if ($('body.index').length) {
        var cntTimes = 0;
        var cusfun = setInterval(function(){
            if ($('#insta-feed > a').length) {
                if ($(window).width() <= 1040 && $(window).width() >= 768) {
                    initInstagramSlider()
                }
                clearInterval(cusfun);
            }
            if (cntTimes > 20) {
                clearInterval(cusfun);
            }
            cntTimes++;
        }, 500);
    }
    $(window).resize(function() {
        if ($('body.having-instagram-slider').length) {
            if ($(window).width() > 1040 || $(window).width() < 768) {
                $('#insta-feed').trigger('destroy.owl.carousel');
                $('#insta-feed').removeClass('owl-carousel');
                $('body.having-instagram-slider').removeClass('having-instagram-slider');
            }
        } else {
            if ($(window).width() <= 1040 && $(window).width() >= 768) {
                initInstagramSlider();
            }
        }
    });

    function initInstagramSlider() {
        $('#insta-feed').parent().append('<div class="insta-lightboxs"></div>');
        $('#insta-feed > a.instafeed-lightbox').appendTo('.insta-lightboxs');
        var instaSlider = $('#insta-feed').addClass('owl-carousel').owlCarousel({
            items: 3,
            stagePadding: 115,
            margin: 16,
            loop:true
        });
        $('#insta-feed.owl-carousel .owl-stage').css('margin-left', '-115px');
        $('body').addClass('having-instagram-slider');
    }
    /*Ajax Add to Cart*/
    $(document).on('click', "form[action='/cart/add'] [type=submit]", function(e) {
        e.preventDefault();
        var formcurrent = $(this).parent();
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: formcurrent.serialize(),
            dataType: 'json',
            success: function (data) {
                var dataShop = '';
                var currencySymbol = '$';
                try {
                    dataShop = JSON.parse(document.body.dataset.shop);
                } catch {
                    console.error('There is no current money format available!');
                }
                if (dataShop && dataShop.moneyFormat) {
                    currencySymbol = dataShop.moneyFormat.replace('{{amount}}', '')
                }
                price = data.price / 100;
                $(formcurrent).parent().append('<div data-module-init="modal" id="modal-cart-noti" class="modal modal--cart modal--active" data-module-initialized="1"><div data-close-modal="" class="modal__overlay"></div><div class="modal__container"><button type="button" data-close-modal="" class="modal__button"><svg viewBox="0 0 320 512" class="modal__button-close icon-times"> <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-times" x="0" y="0"></use> </svg></button><div class="modal__wrapper"><div class="modal__inner"><div class="modal__cart-header"><h3>Item added to cart</h3></div><div class="modal__cart-body"><div class="modal__cart-inner"><div class="modal__cart-image-block"> <figure data-module-init="image" class="js-wrap image modal__cart-image image--cover image--loaded" data-module-initialized="1"><img src="" alt="6000mAh USB-C Power Bank in Teal" srcset="' + data.image +'" class="image__img"></figure></div><div class="modal__cart-content"><h5 class="modal-cart-subtitle modal__cart-subtitle">' + data.product_type + '</h5><h3 class="modal-cart-title modal__cart-title">' + data.product_title + '</h3><div class="modal__cart-info"><p class="modal__cart-quantity">Quantity: ' + data.quantity + '</p><p class="price input-quantity modal__cart-price"><span>' + currencySymbol + price + '</span></p></div></div></div></div><div class="modal__cart-footer"><a href="/collections/all" class="button button--alternate modal__cart-cta">Continue Shopping</a> <a href="/checkout" class="button button--add modal__cart-cta">Checkout</a></div></div></div></div></div>');
                loadminicart()
            },
            error: function (XMLHttpRequest) {
                //get message error in api ajax default Shopify
                var data = eval('(' + XMLHttpRequest.responseText + ')');
                var errorMessage = '';
                if (!!data.message) {
                    errorMessage = data.description
                } else {
                    errorMessage = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
                }
                window.alert('Cannot add item to cart. Please contact site administrator.')
            }
        });
    });
    function loadminicart() {
        $.ajax({
            url: '/cart.js',
            type: "GET",
            dataType: 'json',
            success: function (response) {
                if (response.item_count != 0) {
                    var currencySymbol = '$';
                    var listitemhtml = '';
                    $.each(response.items, function(index) {
                        var dataShop = '';
                        try {
                            dataShop = JSON.parse(document.body.dataset.shop);
                        } catch {
                            console.error('There is no current money format available!');
                        }
                        if (dataShop && dataShop.moneyFormat) {
                            currencySymbol = dataShop.moneyFormat.replace('{{amount}}', '')
                        }
                        index = index + 1;
                        var price = this.price / 100;
                        var itemhtml = '<div class=" cart-layout__row cart-layout__row--dropdown"><div data-module-init="quantity-notification" class="cart-layout__row-inner" data-module-initialized="1"><a href="' + this.url +'" class="cart-layout__col cart-layout__col--image"> <figure class="js-wrap image cart-layout__image image--contain image--loaded"><img src="' + this.image +'" class="image__img" srcset="' + this.image +'"> </figure> </a><div class="cart-layout__col cart-layout__col--content"><div class="cart-layout__header"><div class="cart-layout-type cart-layout__type">' + this.product_type +'</div><h4 class="cart-layout__title"><a href="' + this.url +'" class="cart-row-title cart-layout__title-link">' + this.product_title +'</a></h4>';
                        itemhtml += '<button type="button" class="p-small cart-layout__close">Remove</button></div><div class="cart-property cart-layout__properties"><div class="cart-layout__property-quantity"><div data-module-init="quantity" class="quantity quantity--medium cart-layout__qty-selector js-quantity" data-module-initialized="1"><div class="quantity__control"><button type="button" disabled="disabled" class="quantity__button"><span class="icon-minus"></span></button> <input autocomplete="off" id="quantity-input-4" type="number" name="updates[]" value="" max="" min="1" class="quantity__input input-quantity js-cart-qty input-quantity"> <button type="button" class="quantity__button"><span class="icon-plus"></span></button></div></div></div><div class="cart-layout__property"> '+ this.quantity +' x</div><p class="price cart-layout__price"><span>' + currencySymbol + price +'</span></p></div><div data-module-init="quantity-notification" class="quantity-notification js-quantity-notification " data-module-initialized="1"><span class="js-quantity-notification-content">&nbsp;</span></div> <button type="button" data-url="'+this.variant_id+'" class="p-small cart-layout__close">Remove</button></div></div></div>';
                        listitemhtml = listitemhtml + itemhtml;
                    });
                    var creatcart = '<form action="/cart" method="POST" class="cart-dropdown__form"><div class="custom-padding"><div class="cart-dropdown__items"> '+ listitemhtml +'</div></div><div class="cart-dropdown__footer"><div class="cart-dropdown__subtotal"><div class="cart-dropdown-subtotal cart-dropdown__subtotal-text">Grand Total</div><div class="sub-title cart-dropdown-subtotal-price cart-dropdown__subtotal-price js-grand-total"><span class="wh-original-cart-total"><span class="wh-original-price">' + currencySymbol + response.total_price/100 +' </span></span> <span class="wh-cart-total"></span><div class="additional-notes"><span class="wh-minimums-note"></span><span class="wh-extra-note"></span></div></div></div><div class="cart-dropdown__checkout"><a href="/cart" class="button button--alternate cart-dropdown__checkout-button cart-dropdown__checkout-button--alt">View Cart</a> <input type="submit" name="checkout" value="Checkout" class="button cart-dropdown__checkout-button"></div></div></form>';
                    $('.collection .header__inner .header__cart-dropdown .cart-dropdown__inner').addClass('cart-dropdown__inner--has-items');
                    $('.collection .header__inner .header__cart-dropdown .cart-dropdown__inner').html(creatcart);
                    $('.collection .header__inner .header__triggers .cart-trigger--header').removeClass('cart_trigger--count-empty');
                    $('.collection .header__inner .header__triggers .cart-trigger__count-text').html(response.item_count);
                    $('body').addClass('not-empty-cart-dropdown');
                    $('body').removeClass('empty-cart-dropdown');
                } else {
                    $('.collection .header__inner .header__cart-dropdown .cart-dropdown__inner').removeClass('cart-dropdown__inner--has-items');
                    $('.collection .header__inner .header__triggers .cart-trigger--header').addClass('cart_trigger--count-empty');
                    $('.collection .header__inner .header__cart-dropdown .cart-dropdown .cart-dropdown__inner').html('<div class="cart-dropdown__empty"><h4 class="cart-dropdown-empty cart-dropdown__empty-text">Your cart is currently empty.</h4></div>');
                    $('body').addClass('empty-cart-dropdown');
                    $('body').removeClass('not-empty-cart-dropdown');
                }

            }
        });
    };
    $(document).on('click', '.collection .header__inner .header__cart-dropdown .cart-dropdown__items .cart-layout__close', function(e) {
        e.preventDefault();
        productid = $(this).data('url');
        $.ajax({
            type: 'GET',
            url: '/cart/update.js',
            data: 'updates['+productid+']=0',
            success: function (response) {
                loadminicart();
            },
            error: function (XMLHttpRequest) {}
        });
    });

    document.addEventListener('invalid', (function () {
        return function (e) {
            e.preventDefault();
            if ($('#contact_form .form__block--email input').val() == '') {
                $('#contact_form .form__block--email input').focus();
                $('#contact_form .form__block--email input').addClass('form__error');
                $('#contact_form .form__block--email').append('<span class="form__message custom">This field is required.</span>');
            }
        };
    })(), true);
    $(document).mouseup(function(e) {
        var container = $(".mega-menu__item");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0)
        {
            container.find('a.title-opening-dropdown').trigger('click');
        }
    });

    var vendor = null;
    var device = null;
    var model = null;
    var categories = null;
    document.addEventListener('advanced-search-changed', function (e) {
        var vendorNew = $(e.target).find('.product-advance-search__item select[name="vendor"]').val();
        var deviceNew = $(e.target).find('.product-advance-search__item select[name="device"]').val();
        var modelNew = $(e.target).find('.product-advance-search__item select[name="model"]').val();
        var categoriesNew = $(e.target).find('.product-advance-search__item select[name="categories"]').val();
        var checkVendor = false;
        var checkDevice = false;
        var checkModel = false;
        let url = window.location.origin + '/collections/all/';
        if (vendorNew && vendorNew != vendor) {
            checkVendor = true;
            vendor = vendorNew;
            url += 'Vendor_' + vendor.replace(' ', '-').replace('.', '-');
        } else {
            url += 'Vendor_' + vendor.replace(' ', '-').replace('.', '-');
            if (deviceNew && deviceNew != device) {
                checkDevice = true;
                device = deviceNew;
                url += '+Device_' + device.replace(' ', '-').replace('.', '-');
            } else {
                url += '+Device_' + device.replace(' ', '-').replace('.', '-');
                if (modelNew && modelNew != model) {
                    checkModel = true;
                    model = modelNew;
                    url += '+Model_' + model.replace(' ', '-').replace('.', '-');
                } else {
                    url += '+Model_' + model.replace(' ', '-').replace('.', '-');
                    if (categoriesNew && categoriesNew != categories) {
                        categories = categoriesNew;
                        url += '+Categories_' + categories.replace(' ', '-').replace('.', '-');
                    }
                }
            }
        }
        url += '?view=tags'

        $.ajax({
            url: encodeURI(url).replace(/\%20/g, '-')
        }).done(function(response) {
            var allTags = JSON.parse(response).product_tags;
            var deviceTags = allTags.filter(function(item) {
                return item.indexOf('Device_') == 0
            });
            var modelTags = allTags.filter(function(item) {
                return item.indexOf('Model_') == 0
            });
            var categoriesTags = allTags.filter(function(item) {
                return item.indexOf('Categories_') == 0
            });
            if (checkVendor) {
                $(e.target).find('.product-advance-search__item select[name="device"]').val('').prop('disabled', false);
                $(e.target).find('.product-advance-search__item select[name="model"]').val('').prop('disabled', 'disabled');
                $(e.target).find('.product-advance-search__item select[name="categories"]').val('').prop('disabled', 'disabled');
                $(e.target).find('.product-advance-search__item select[name="device"] option:not([disabled="disabled"])').remove();
                $(e.target).find('.product-advance-search__item select[name="model"] option:not([disabled="disabled"])').remove();
                $(e.target).find('.product-advance-search__item select[name="categories"] option:not([disabled="disabled"])').remove();
                if ($(e.target).find('.product-advance-search__item select[name="device"] + .style-select').length) {
                    $(e.target).find('.product-advance-search__item select[name="device"] + .style-select .ss-dropdown .ss-option:not(.disabled)').hide();
                    $(e.target).find('.product-advance-search__item select[name="model"] + .style-select .ss-dropdown .ss-option:not(.disabled)').hide();
                    $(e.target).find('.product-advance-search__item select[name="categories"] + .style-select .ss-dropdown .ss-option:not(.disabled)').hide();
                    $(e.target).find('.product-advance-search__item select[name="device"] + .style-select .ss-selected-option').text('Select Device');
                    $(e.target).find('.product-advance-search__item select[name="model"] + .style-select .ss-selected-option').text('Select Model');
                    if ($(e.target).closest('.header').length) {
                        $(e.target).find('.product-advance-search__item select[name="categories"] + .style-select .ss-selected-option').text('Select Categories');
                    } else {
                        $(e.target).find('.product-advance-search__item select[name="categories"] + .style-select .ss-selected-option').text('Categories');
                    }
                }
                if (deviceTags.length) {
                    var deviceList = [];
                    $('#shop-by-device-tree > li > span').each(function() {
                      if ($(this).text().toLowerCase() == ('Vendor_' + vendor).toLowerCase()) {
                        $(this).next('ul').children('li').children('span').each(function() {
                          deviceList.push($(this).text());
                        });
                      }
                    });
                    for (i = 0; i < deviceTags.length; i++) {
                        if (deviceList.length) {
                          if (deviceList.indexOf(deviceTags[i]) < 0) {
                            continue;
                          }
                        }
                        var value = deviceTags[i].replace('Device_', '');
                        $(e.target).find('.product-advance-search__item select[name="device"]').append('<option value="'+ value +'">'+ value +'</option>');
                        if ($(e.target).find('.product-advance-search__item select[name="device"] + .style-select').length) {
                            $(e.target).find('.product-advance-search__item select[name="device"] + .style-select .ss-dropdown .ss-option[data-value="'+value+'"]').show();
                        }
                    }
                }
            } else {
                if (checkDevice) {
                    $(e.target).find('.product-advance-search__item select[name="model"]').val('').prop('disabled', false);
                    $(e.target).find('.product-advance-search__item select[name="categories"]').val('').prop('disabled', 'disabled');
                    $(e.target).find('.product-advance-search__item select[name="model"] option:not([disabled="disabled"])').remove();
                    $(e.target).find('.product-advance-search__item select[name="categories"] option:not([disabled="disabled"])').remove();
                    if ($(e.target).find('.product-advance-search__item select[name="model"] + .style-select').length) {
                        $(e.target).find('.product-advance-search__item select[name="model"] + .style-select .ss-dropdown .ss-option:not(.disabled)').hide();
                        $(e.target).find('.product-advance-search__item select[name="categories"] + .style-select .ss-dropdown .ss-option:not(.disabled)').hide();
                        $(e.target).find('.product-advance-search__item select[name="model"] + .style-select .ss-selected-option').text('Select Model');
                        if ($(e.target).closest('.header').length) {
                            $(e.target).find('.product-advance-search__item select[name="categories"] + .style-select .ss-selected-option').text('Select Categories');
                        } else {
                            $(e.target).find('.product-advance-search__item select[name="categories"] + .style-select .ss-selected-option').text('Categories');
                        }
                    }
                    var modelList = [];
                    $('#shop-by-device-tree > li > ul > li > span').each(function() {
                      if ($(this).text().toLowerCase() == ('Device_' + device).toLowerCase()) {
                        $(this).next('ul').children('li').children('span').each(function() {
                          modelList.push($(this).text());
                        });
                      }
                    });
                    if (modelTags.length) {
                        for (var i = 0; i < modelTags.length; i++) {
                            if (modelList.length) {
                              if (modelList.indexOf(modelTags[i]) < 0) {
                                continue;
                              }
                            }
                            var value = modelTags[i].replace('Model_', '');
                            var valueShort = value;
                            if (value.indexOf('Samsung ') == 0) {
								              valueShort = value.replace('Samsung ', '');
                            }
                            $(e.target).find('.product-advance-search__item select[name="model"]').append('<option value="'+ value +'">'+ valueShort +'</option>');
                            if ($(e.target).find('.product-advance-search__item select[name="model"] + .style-select').length) {
                                $(e.target).find('.product-advance-search__item select[name="model"] + .style-select .ss-dropdown .ss-option[data-value="'+value+'"]').text(valueShort).show();
                            }
                        }
                    }
                } else {
                    if (checkModel) {
                        $(e.target).find('.product-advance-search__item select[name="categories"]').val('').prop('disabled', false);;
                        $(e.target).find('.product-advance-search__item select[name="categories"] option:not([disabled="disabled"])').remove();
                        if ($(e.target).find('.product-advance-search__item select[name="categories"] + .style-select').length) {
                            $(e.target).find('.product-advance-search__item select[name="categories"] + .style-select .ss-dropdown .ss-option:not(.disabled)').hide();
                            if ($(e.target).closest('.header').length) {
                                $(e.target).find('.product-advance-search__item select[name="categories"] + .style-select .ss-selected-option').text('Select Categories');
                            } else {
                                $(e.target).find('.product-advance-search__item select[name="categories"] + .style-select .ss-selected-option').text('Categories');
                            }
                        }
                        if (categoriesTags.length) {
                            for (var i = 0; i < categoriesTags.length; i++) {
                                var value = categoriesTags[i].replace('Categories_', '');
                                $(e.target).find('.product-advance-search__item select[name="categories"]').append('<option value="'+ value +'">'+ value +'</option>');
                                if ($(e.target).find('.product-advance-search__item select[name="categories"] + .style-select').length) {
                                    $(e.target).find('.product-advance-search__item select[name="categories"] + .style-select .ss-dropdown .ss-option[data-value="'+value+'"]').show();
                                }
                            }
                        }
                    }
                }
            }
        });
    });

    $(window).on('load', function() {
        if ($('.product-details__left-block .product-images .product-images__inner.carousel').length) {
            var cntItv = 0;
            var myItv = setInterval(function() {
                if ($('.product-details__left-block .product-images .product-images__inner.carousel').height() < 100) {
                    var resizeEvent = window.document.createEvent('UIEvents');
                    resizeEvent.initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(resizeEvent);
                } else {
                    clearInterval(myItv);
                }
                cntItv++;
                if (cntItv > 100) {
                    clearInterval(myItv);
                }
            }, 500);
        }
    });
    $(".search-bar__form .search-bar__input").focus(function(){
        $(this).closest('.search-bar__form').addClass('focus-input');
    });
    $(".search-bar__form .search-bar__input").focusout(function(){
        $(this).closest('.search-bar__form').removeClass('focus-input');
    });
    document.addEventListener('header-cart-quantity-changed', function (e) {
        if ($('.cart-trigger--header').hasClass('cart_trigger--count-empty')) {
            $('body').addClass('empty-cart-dropdown');
            $('body').removeClass('not-empty-cart-dropdown');
        } else {
            $('body').removeClass('empty-cart-dropdown');
            $('body').addClass('not-empty-cart-dropdown');
        }
    });
    if ($(window).width() < 1025) {
        $(document).on('click', function (e) {
            var container = $(".product-images__image-zoom");
            if (!container.is(e.target) && container.has(e.target).length === 0)
            {
                container.removeClass("image-zoom---activate");
            }
        });
    }

    $("header.header").sticky({topSpacing:0});
    $('body').on('click touchend' , '.wtb-button',function (e) {
      e.preventDefault()
      let product = $(this).parents('.bc-sf-filter-product-item-inner'),
          name = product.find('.cart-row-title').text(),
          type = product.find('.cart-layout-type').text(),
          image = product.find('.bc-sf-filter-product-item-main-image').attr('src'),
          title = product.attr('data-wtb-title'),
          logo = product.attr('data-wtb-logo'),
          url = product.attr('data-wtb-url');
      image !== "" ? $('.wtb-product-image img').attr('src', image) : $('.wtb-product-image img').attr('src', "");
      logo !== "" ? $('.wtb-product-logo').attr('src', logo) : $('.wtb-product-logo').attr('src', "");
      url !== "" ? $('.wtb-direct').attr('href',url) : $('.wtb-direct').attr('href',"#");
      name !== "" ? $('.wtb-product-name').text(name) : $('.wtb-product-name').text("");
      type !== "" ? $('.wtb-product-type').text(type) : $('.wtb-product-type').text("");
      title !== "" ? $('.wtb-web').text(title) : $('.wtb-web').text("");
      $('#wtb-popup').show();
    })
    $('body').on('click' , '.js-close',function (e) {
      $('#wtb-popup').hide();
    })
  $(document).mouseup(function(e) {
    var container = $(".wtb-popup");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('#wtb-popup').hide();
    }
  });

});
